webpackJsonp([35783957827783],{

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  ", ";\n\n  box-shadow: 0 0 10px #454545;\n"], ["\n  ", ";\n\n  box-shadow: 0 0 10px #454545;\n"]);
	
	var _styledComponents = __webpack_require__(12);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ShadowImage = _styledComponents2.default.img(_templateObject, function (_ref) {
	  var width = _ref.width;
	
	  if (width) {
	    return "width: " + width;
	  }
	});
	
	exports.default = ShadowImage;
	module.exports = exports["default"];

/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/us-montreal.be21bb9b.jpg";

/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/us-pikes-peak.127b5415.jpg";

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  margin-top: 1.5rem;\n\n  text-align: center;\n\n  p {\n    font-size: 1.3rem;\n  }\n"], ["\n  margin-top: 1.5rem;\n\n  text-align: center;\n\n  p {\n    font-size: 1.3rem;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n\n  margin: 0.5rem;\n"], ["\n  flex: 1;\n\n  margin: 0.5rem;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  width: 30rem;\n"], ["\n  width: 30rem;\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(177);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(12);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _FlexRow = __webpack_require__(63);
	
	var _FlexRow2 = _interopRequireDefault(_FlexRow);
	
	var _Card = __webpack_require__(62);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _ShadowImage = __webpack_require__(46);
	
	var _ShadowImage2 = _interopRequireDefault(_ShadowImage);
	
	var _usMontreal = __webpack_require__(634);
	
	var _usMontreal2 = _interopRequireDefault(_usMontreal);
	
	var _usPikesPeak = __webpack_require__(635);
	
	var _usPikesPeak2 = _interopRequireDefault(_usPikesPeak);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CenterContent = _styledComponents2.default.div(_templateObject);
	
	var RowItem = _styledComponents2.default.div(_templateObject2);
	
	var SizedImage = _ShadowImage2.default.extend(_templateObject3);
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _Card2.default,
	      { header: "Will You Celebrate Our Love With Us?" },
	      _react2.default.createElement(
	        CenterContent,
	        null,
	        _react2.default.createElement(SizedImage, { src: _usMontreal2.default }),
	        _react2.default.createElement(
	          "p",
	          null,
	          "We invite you to join us",
	          _react2.default.createElement("br", null),
	          "in celebrating our love.",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          "On this day we will marry the one",
	          _react2.default.createElement("br", null),
	          "we laugh with, live for, dream with, love.",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          "We have chosen to continue",
	          _react2.default.createElement("br", null),
	          "our growth through marriage.",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          "Please join",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Adam Michael Fishman"
	          ),
	          _react2.default.createElement("br", null),
	          "and",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Casey Todd Lee"
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          "Saturday the eighteenth of August",
	          _react2.default.createElement("br", null),
	          "two thousand eighteen",
	          _react2.default.createElement("br", null),
	          "at ten thirty in the morning.",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          "Hilton Denver Inverness",
	          _react2.default.createElement("br", null),
	          "200 Inverness Drive West",
	          _react2.default.createElement("br", null),
	          "Englewood, Colorado",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          "Formal attire",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          "RSVP by Sunday the fifteenth of July."
	        ),
	        _react2.default.createElement(SizedImage, { src: _usPikesPeak2.default })
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-79e667dca01f234c91ed.js